import {Component, DoCheck, EventEmitter, Input, KeyValueDiffers, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {LoaderService} from '../shared/loader/loader-service.services';
import {ApiService} from '../services/api.service';
import {ResultFields} from '../modals/ResultFields';
import {DataSharingService} from '../services/data-sharing.service';
import {UtilService} from '../services/UtilService';
import {Index} from '../modals/Index';
import {Store} from '@ngxs/store';

@Component({
  selector: 'app-iboxx-side-bar',
  templateUrl: './iboxx-side-bar.component.html',
  styleUrls: ['./iboxx-side-bar.component.scss']
})
export class IboxxSideBarComponent implements OnInit, DoCheck {
  menuConfig = {
    // 'collapse': true,
    // 'defaultPage': {
    //   'navigationObj': { 'childName': '', 'parentName': 'iBoxxIndices', 'rootKey': 'screener' }
    // }
  };
  tabList = ['screener', 'documentation'];
  pageName = '';
  indexType = 'all';
  searchResult: ResultFields[] = [];
  filteredSearchResult: ResultFields[] = [];
  searchInput = '';
  searchTimedOut = false;
  searched = false;
  showLoader = false;
  spanStart = '<span class="highlighted-text">';
  spanEnd = '</span>';
  splitFlag = '';
  matchFlag = '';
  errorMessage = '';
  showErrorMsg = false;
  private replaced = '';
  private index: Index | undefined;
  indicesDump: any;
  items = [
    {
      key: 'screener',
      title: 'Indices',
      link: '',
      target: 'child',
      children: [{
        key: 'iBoxxIndices',
        title: 'iBoxx Indices',
        link: '',
        target: 'child',
        children: [{
          key: 'allIndices',
          title: 'All',
          link: 'iBoxx/Screener',
          level: 2
        }, {
          key: 'futuresIndices',
          title: 'iBoxx Futures',
          link: 'iBoxx/Futures/Screener',
          level: 2
        }, {
          key: 'standardizedIndices',
          title: 'iBoxx Standardized TRS',
          link: 'iBoxx/TRS/Screener',
          level: 2
        }, {
          key: 'esgIndices',
          title: 'iBoxx ESG/Sustainable Indices',
          link: 'iBoxx/ESG/Screener',
          level: 2
        }],
        routeLabel: 'page',
        level: 1
      }, {
        key: 'carbonIndices',
        title: 'Carbon Indices',
        link: 'Carbon/Home',
        routeLabel: 'page',
        level: 1
        // }, {
        //   key: 'emixIndices',
        //   title: 'EMIX Indices',
        //   link: 'EMIX/Screener',
        //   routeLabel: 'page',
        //   level: 1
      }],
      level: 0,
      icon: 'markets',
      home: false
    },
    {
      key: 'docs',
      title: 'Documentation',
      target: 'child',
      link: '',
      children: [{
        key: 'iBoxxDocs',
        title: 'iBoxx Indices',
        link: '',
        routeLabel: 'page',
        level: 1,
        target: 'child',
        children: [{
          key: 'allIndices',
          title: 'All',
          link: 'Indices/docs/page?docFor=iBoxx',
          level: 2
        }, {
          key: 'futuresIndices',
          title: 'iBoxx Futures',
          link: 'Futures/docs/page?docFor=iBoxx',
          level: 2
        }, {
          key: 'standardizedIndices',
          title: 'iBoxx Standardized TRS',
          link: 'TRS/docs/page?docFor=iBoxx',
          level: 2
        }, {
          key: 'esgIndices',
          title: 'iBoxx ESG/Sustainable Indices',
          link: 'ESG/docs/page?docFor=iBoxx',
          level: 2
        }],
      }, {
        key: 'carbonDocs',
        title: 'Carbon Indices',
        link: 'Indices/docs/page?docFor=Carbon',
        routeLabel: 'page',
        level: 1
        // }, {
        //   key: 'emixDocs',
        //   title: 'EMIX Indices',
        //   link: 'EMIX/docs/page?docFor=EMIX',
        //   routeLabel: 'page',
        //   level: 1
      }],
      level: 0,
      routeLabel: 'page',
      icon: 'document-library'
    },
  ];

  // ALERT BOX VARIABLES
  alertMessage = '';
  alertType = 'info';
  showAlert = false;
  errorType = 'error';
  @Input() clickedOutside = true;
  @Output() headlineIndices = new EventEmitter<any>();
  @Output() EMIXIndices = new EventEmitter<any>();
  @Output() s3ContentsLoaded = new EventEmitter<boolean>();

  // ALERT MESSAGE FOR BETA
  indexNotInHeadline = false;
  indexNotFoundMsg = 'Not yet available to view on website. Please contact indices@ihsmarkit.com for more information.';
  differ: any;
  timeout: any = null;

  constructor(private shareService: DataSharingService, private utilService: UtilService, private route: Router,
              private loader: LoaderService, private apiService: ApiService, private differs: KeyValueDiffers, private store: Store) {
    this.differ = this.differs.find({}).create();
    this.store.select(state => state.indexState.stateName).subscribe((resp: any) => {
      this.indexType = resp;
    });
  }

  ngOnInit(): void {
    this.loader.show();
    this.apiService.getS3Objects().subscribe((resp: any) => {
      this.shareService.s3Contents = JSON.parse(JSON.stringify(resp));
      this.s3ContentsLoaded.emit(true);
      if (this.shareService.headlineIndices){
        this.loader.hide();
      }
    });

    this.apiService.getIndicesDump().subscribe((resp: any) => {
      this.indicesDump = resp;
    });

    this.apiService.getHolidayCalendar().subscribe((resp: any) => {
      this.shareService.holidays = resp;
    });

    // this.apiService.getHeaderFooter().subscribe((resp: any) => {
    //   console.log(resp);
    // });

    this.apiService.getEuriborValues().subscribe((resp: any) => {
      const arr: any[] = [];
      resp.splice(1).forEach((data: any) => {
        const obj: any = {};
        obj[data.split(':')[0].trim()] = data.split(':')[1].trim();
        arr.push(obj);
      });
      this.shareService.euriborValue = arr;
    });

    if (this.shareService.headlineIndices === undefined) {
      this.apiService.getHeadlineIndices().subscribe((resp: any) => {
        this.shareService.headlineIndices = (resp.headlineIndices);
        if (this.shareService.s3Contents.length > 0){
          this.loader.hide();
        }
        this.headlineIndices.emit(resp.headlineIndices);
        this.shareService.headlineIDs = resp.headlineIDs;
      });
      // this.apiService.getHeadlineIndicesFromScreener('', ).subscribe((resp: any) => {
        //   console.log('screener: ', resp);
      //   this.shareService.headlineIndices = (resp.headlineIndices);
      //   this.headlineIndices.emit(resp.headlineIndices);
      //   this.shareService.headlineIDs = resp.headlineIDs;
      //   this.loader.hide();
      // });
    } else {
      this.loader.hide();
    }
    if (this.shareService.EMIXIndices === undefined){
      // this.apiService.getAllEmixIndices().subscribe((resp: any) => {
      //   this.shareService.EMIXIndices = resp;
      //   this.EMIXIndices.emit(resp);
      // });
    }
  }

  ngDoCheck(): void {
    this.changePageName(window.location.href);
    const change = this.differ.diff(this);
    if (change) {
      change.forEachChangedItem((item: any) => {
        if (item.key === 'clickedOutside') {
          this.indexNotInHeadline = false;
          // this.shareService.listOfTabs.subscribe((tab: any) => {
          //   this.showAlert = tab.length > 6;
          // });
          // @ts-ignore
          const tab = JSON.parse(window.sessionStorage.getItem('tabList')) ? JSON.parse(window.sessionStorage.getItem('tabList')) :
            {
              all: [],
              futures: [],
              trs: [],
              esg: [],
            };
          this.showAlert = tab.length > 7;
        }
      });
    }
  }

  navigateToPage(event: any): void {
    this.changePageName(event.link);
    this.indexType = '';
    this.searchInput = '';
    this.searched = false;
    this.route.navigateByUrl(event.link);
  }

  searchTerm(event: any): void {
    clearTimeout(this.timeout);
    this.searchResult = [];
    this.searched = false;
    this.showLoader = true;
    this.timeout = setTimeout(() => {
      if (event.key !== 'Enter') {
        if (this.searchInput.trim().length > 0 && event.type !== 'click') {
          this.runSearchInDump();
        } else {
          this.searched = false;
          this.showLoader = false;
          this.searchInput = '';
        }
      }
    }, 1000);
  }

  runSearchInDump(): void{
    const searchResult = this.indicesDump.filter((index: any) => {
      return this.searchInput.toUpperCase().split(' ').every((input: string) =>  index.indexName.toUpperCase().includes(input))
        || this.searchInput.toUpperCase().split(' ').every((input: string) =>  index.bbgTickerTri.toUpperCase().includes(input))
        || this.searchInput.toUpperCase().split(' ').every((input: string) =>  index.isinTri.toUpperCase().includes(input));
    });

    this.filteredSearchResult = [];
    this.searchTimedOut = false;
    if (searchResult.length <= 1000) {
      searchResult.forEach((result: any) => {
        const index = new ResultFields();
        index.isin = this.highlightTermIgnoreCase(result.isinTri.trim());
        index.bbgTicker = this.highlightTermIgnoreCase(result.bbgTickerTri.trim());
        index.name = this.highlightTermIgnoreCase(result.indexName.trim());
        index.id = result.id.trim();
        index.asOf = result.asOf.trim();

        this.filteredSearchResult.push(index);
      });
      this.skimDuplicates();
      this.searchResult = Object.assign([], this.filteredSearchResult);
    }else{
      this.searchTimedOut = true;
    }
    this.searched = true;
    this.showLoader = false;
  }

  runSearch(): void {
    this.apiService.getSearchResult(this.searchInput, ).subscribe((resp: any) => {
      this.filteredSearchResult = this.retrieveIndexDetailsFromSearchResult(resp);
      if (this.filteredSearchResult.length > 0) {
        this.apiService.getIndexNameFor(this.filteredSearchResult.map((res: any) => encodeURIComponent(res.id)).join(','),
          ).subscribe((response: any) => {
          this.filteredSearchResult.forEach((field: any) => {
            const index = response.find((rsp: any) => {
              if (field.id === rsp.id) {
                return rsp;
              }
            });
            if (index) {
              // if (index.isinTri !== null && index.isinTri !== undefined) {
              //   field.isin = this.highlightTermIgnoreCase(index.isinTri);
              // }
              if (field.name !== null && field.name !== undefined) {
                field.name = this.highlightTermIgnoreCase(index.indexName);
              }
              // if (field.bbgTicker !== null && field.bbgTicker !== undefined) {
              //   field.bbgTicker = this.highlightTermIgnoreCase(index.bbgTickerTri);
              // }
              field.inflationAdjustment = index.inflationAdjustment;
            }
          });
          this.searchResult = Object.assign([], this.filteredSearchResult);
          this.searched = true;
        });

      } else {
        this.searchResult = [];
        this.searched = true;
      }
    });
  }

  skimDuplicates(): any{
    const indices = [... new Set(this.filteredSearchResult.map((result: any) => result.name.replace(/(<([^>]+)>)/ig, '')))];
    const filteredSearchResult = [];
    for (const index of indices) {
      const instances = this.filteredSearchResult.filter((result: any) => result.name.replace(/(<([^>]+)>)/ig, '') === index);
      if (instances.length > 1){
        if (instances.map((instance: any) => instance.id).some(elem => this.shareService.headlineIDs.includes(elem))){
          filteredSearchResult.push(instances.filter((instance: any) =>
            this.shareService.headlineIndices.map((res: any) => res.id).includes(instance.id))[0]);
        }else{
          filteredSearchResult.push(instances[0]);
        }
      }else{
        filteredSearchResult.push(instances[0]);
      }
    }
    this.filteredSearchResult = Object.assign([], filteredSearchResult);
    this.filteredSearchResult.sort((r1: any, r2: any) => r1.name < r2.name ? -1 : 1);
  }

  retrieveIndexDetailsFromSearchResult(searchResult: any): any {
    const indexResult: ResultFields[] = [];
    searchResult.forEach((result: any) => {
      const index = new ResultFields();
      index.isin = result.id;
      index.type = result.type;
      index.name = result.name;
      index.bbgTicker = result.fields.bbgTicker;
      result.refs = result.refs
        .filter((ref: any) => {
          if (ref.namespace === 'fiindices' && ref.entity === 'Index' && ref.id.includes('_calc')) {
            return ref;
          }
        })
        .sort((op1: any, op2: any) => op1.asOfDateTime > op2.asOfDateTime ? -1 : 1);
      index.references = result.refs.map((ref: any) => ref.id);
      index.id = result.refs.length > 0 ?
        this.findInHeadlineIndices(index.references) ? this.findInHeadlineIndices(index.references) : result.refs[0].id : null;

      if (index.id) {
        indexResult.push(index);
      }
    });
    return indexResult;
  }

  findInHeadlineIndices(references: string[]): string | undefined{
    return references.find((id: string) => this.shareService.headlineIDs.includes(id));
  }

  navigateToIndexByName(index: any): void {
    // @ts-ignore
    const tabGroup = JSON.parse(window.sessionStorage.getItem('tabList')) ? JSON.parse(window.sessionStorage.getItem('tabList')) :
      {
        all: [],
        futures: [],
        trs: [],
        esg: [],
      };
    this.tabList = this.indexType !== 'emix' && this.indexType !== '' && tabGroup[this.indexType].length > 0 ?
      tabGroup[this.indexType] : ['screener', 'documentation'];
    const indexName = index.name.replace(/(<([^>]+)>)/ig, '');
    const searchedIndex = this.filteredSearchResult.find((result: any) => {
      if (result.name.replace(/(<([^>]+)>)/ig, '') === indexName && result.id === index.id) {
        return result;
      }
    });
    if (searchedIndex) {
      if (this.shareService.headlineIDs.includes(searchedIndex.id)) {
        if (!this.tabList.includes(searchedIndex.name + '?' + searchedIndex.inflationAdjustment)) {
          if (this.tabList.length < 7) {
            this.apiService.getIndexDetail('id', encodeURIComponent(searchedIndex.id),
              ).subscribe((resp: any) => {
              this.index = resp;
              this.openIndexDetailsTab(this.index, this.index?.indexName + '?' + this.index?.inflationAdjustment);
            });
          } else {
            this.openAlert('Maximum 5 indices can be displayed');
          }
        } else {
          this.showAlert = false;
          this.searchInput = '';
          this.searched = false;
          if (window.location.pathname.includes('details')) {
            window.location.href = window.location.href.split('=')[0] + '=' + searchedIndex.id;
          } else {
            this.route.navigateByUrl('iBoxx/details/index?id=' + searchedIndex.id);
          }
        }
      } else {
        this.indexNotInHeadline = true;
      }
    }
  }

  navigateToIndexByIsin(isin: string): void {
    // @ts-ignore
    const tabs = JSON.parse(window.sessionStorage.getItem('tabList')) ? JSON.parse(window.sessionStorage.getItem('tabList')) : [];
    if (tabs.length < 7) {
      const isinStripped = isin.replace(/(<([^>]+)>)/ig, '');
      const index = this.filteredSearchResult.find((result: any) => {
        if (result.isin.replace(/(<([^>]+)>)/ig, '') === isinStripped) {
          return result;
        }
      });
      if (index) {
        const headlineIndexID = this.findInHeadlineIndices(index.references);
        if (headlineIndexID) {
          this.apiService.getIndexDetail('id', headlineIndexID, ).subscribe((resp: any) => {
            this.index = resp;
            this.openIndexDetailsTab(this.index, isinStripped);
          });
        } else {
          this.indexNotInHeadline = true;
        }
      }
    } else {
      this.openAlert('Maximum 5 indices can be displayed');
    }
  }


  openIndexDetailsTab(index: any, tabName: string): void {
    // @ts-ignore
    const tabGroup = JSON.parse(window.sessionStorage.getItem('tabList')) ? JSON.parse(window.sessionStorage.getItem('tabList')) :
      {
        all: [],
        futures: [],
        trs: [],
        esg: [],
      };
    const tabs =  this.indexType !== 'emix' && this.indexType !== '' && tabGroup[this.indexType].length > 0 ?
      tabGroup[this.indexType] : ['screener', 'documentation'];
    if (!tabs.includes(tabName)) {
      tabs.push(tabName);
    }
    if (tabs.length > 1) {
      this.tabList = Object.assign([], tabs);
    } else {
      this.tabList.push(tabName);
    }
    this.shareService.currentTab = tabName;
    this.shareService.tabList.next(this.tabList);
    this.utilService.saveTabListFor(this.indexType === 'emix' || this.indexType === '' ? 'all' : this.indexType, this.tabList);
    if (index !== undefined) {
      // @ts-ignore
      this.shareService.searchedData.push(index);
    }
    this.searchInput = '';
    this.searched = false;
    if (window.location.pathname.includes('details')) {
      window.location.href = window.location.href.split('=')[0] + '=' + index.id;
    } else {
      this.route.navigateByUrl('iBoxx/details/index?id=' + index.id);
    }
  }

  highlightTermIgnoreCase(content: string): string {
    let searchInput = [];
    if (this.searchInput !== undefined && this.searchInput != null && this.searchInput.length > 0 && this.searchInput[0] !== '.') {
      searchInput = this.searchInput.toUpperCase().split(' ');
      this.replaced = content;
      for (const searchPattern of searchInput) {
        const index = this.replaced.toUpperCase().indexOf(searchPattern);
        if (index > -1) {
          const substr = this.replaced.substr(index, searchPattern.length);
          this.replaced = this.replaced.replace(substr, '#' + substr + '*');
        }
      }
    }
    if (this.replaced.match(/#/g)) {
      // @ts-ignore
      this.replaced = this.replaced.match(/#/g).length === searchInput.length ? this.replaced.replaceAll('#', this.spanStart) :
        // @ts-ignore
        this.replaced.replaceAll('#', '');
    }
    if (this.replaced.match(/\*/g)) {
      // @ts-ignore
      this.replaced = this.replaced.match(/\*/g).length === searchInput.length ? this.replaced.replaceAll('*', this.spanEnd) :
        // @ts-ignore
        this.replaced.replaceAll('*', '');
    }
    return this.replaced;
  }

  openAlert(message: string): void {
    this.searchInput = '';
    this.searched = false;
    this.showAlert = true;
    this.alertMessage = message;
  }

  closeAlert(): void {
    this.showAlert = false;
    this.indexNotInHeadline = false;
    this.showErrorMsg = false;
  }

  mailMe(): void {
    window.location.href = 'mailto: indices@ihsmarkit.com?subject=files&body=';
  }

  changePageName(URL: string): void {
    this.pageName = this.getNameForIndex(URL);
    if (URL.includes('/iBoxx/')) {
      this.utilService.highlightSideMenuNavFor('iBoxx');
    }
    if (URL.includes('/Carbon/')) {
      this.utilService.highlightSideMenuNavFor('Carbon');
    }
    if (URL.includes('/EMIX/')) {
      this.utilService.highlightSideMenuNavFor('EMIX');
    }
    if (URL.includes('docs')) {
      this.utilService.highlightSideMenuNavFor('docs');
    }
    if (URL.includes('news')) {
      this.utilService.highlightSideMenuNavFor('news');
    }
  }

  getNameForIndex(URL: string): string{
    if (URL.includes('ESG')){
      return 'IBOXX ESG/SUSTAINABLE INDICES';
    }
    if (URL.includes('TRS')){
      return 'IBOXX STANDARDIZED TRS INDICES';
    }
    if (URL.includes('Futures')){
      return 'IBOXX FUTURES INDICES';
    }
    if (URL.includes('details')){
      switch (this.indexType) {
        case 'futures':
          return 'IBOXX FUTURES INDICES';
        case 'trs':
          return 'IBOXX STANDARDIZED TRS INDICES';
        case 'esg':
          return 'IBOXX ESG/SUSTAINABLE INDICES';
      }
    }
    if (URL.includes('iBoxx')){
      return 'IBOXX INDICES';
    }
    if (URL.includes('Carbon')){
      return 'CARBON INDICES';
    }
    if (URL.includes('EMIX')){
      return 'EMIX INDICES';
    }
    return '';
  }
}
